import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const HarmonicConjugate = () => (
  <QPhototModuleSubtopic
    title="Harmonic conjugate"
    videos={[
      "https://www.youtube.com/embed/OQQqbV32b78"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_5.png"},
        {image:"/cvla_6.png"},
    ]}
    exampleVideos={[]}
  />
);

export default HarmonicConjugate;
